import { watch, onUnmounted } from '@vue/composition-api';

const DESCRIPTION_MAX_SIZE = 120;
const DESCRIPTION =
  'コンサルティングの依頼はこちらから。ビザスクのスポットコンサルなら様々な業界・業務の経験者に1時間から対面/電話で相談できます。業界調査やユーザーインタビュー、新規事業や起業の相談などに活用できます。';
const DESCRIPTION_WITH_KEYWORD =
  'に関する相談はこちらから。ビザスクのスポットコンサルなら様々な業界・業務の経験者に1時間から対面/電話で相談できます。業界調査やユーザーインタビュー、新規事業や起業の相談などに活用できます。';

export const useDocumentDescription = (descriptionFunction: () => string) => {
  const unwatch = watch(
    descriptionFunction,
    newQuery => {
      const description = newQuery
        ? `${newQuery}${DESCRIPTION_WITH_KEYWORD}`
        : DESCRIPTION;
      document
        .querySelector('meta[name=description]')
        ?.setAttribute(
          'content',
          description.substring(0, DESCRIPTION_MAX_SIZE),
        );
    },
    { immediate: true },
  );

  onUnmounted(unwatch);
};
